import styled, {css} from 'styled-components'
import Box, {BoxProps} from './Box'

import type {DefaultTheme} from 'styled-components'

const SECTION_TYPES = {
  medium: {
    $py: [32, 60],
    paddingBottom: [64, 120],
  },
  large: {
    $py: [48, 88],
    paddingBottom: [48, 88],
  },
} as const
export interface SectionProps extends BoxProps {
  $withLastChildPadding?: boolean
  type?: keyof typeof SECTION_TYPES
  background?: keyof DefaultTheme['colors']
  $noPaddingTop?: boolean
  $noPaddingBottom?: boolean
}

// ! --offset-top-0 and --offset-bottom-0
const Section = styled(Box).attrs(({type = 'medium', ...props}: SectionProps) => {
  const {$py} = SECTION_TYPES[type]
  return {
    $py,
    as: 'section',
    ...props,
  }
})<SectionProps>`
  ${({background, theme}) =>
    background &&
    css`
      background: ${theme.colors[background]};
    `}

  ${({theme, $withLastChildPadding = true, type = 'medium'}) =>
    $withLastChildPadding &&
    css`
      &:last-child {
        ${theme.normalizeStyles({
          paddingBottom: SECTION_TYPES[type].paddingBottom,
        })}
      }
    `}

    ${({$noPaddingTop}) =>
    $noPaddingTop &&
    css`
      padding-top: 0;
    `}

    ${({$noPaddingBottom}) =>
    $noPaddingBottom &&
    css`
      padding-bottom: 0;
    `}
`

export default Section
